/**
 * Polling interval (in milliseconds) for refreshing pre-signed URLs.
 *
 * Pre-signed URLs expire after 1 hour (3600 seconds). This interval is set to
 * 3500 seconds (approximately 58 minutes) to ensure new URLs are fetched before
 * the current ones expire, preventing interruptions in downloads.
 */
export const presignedURLRefreshInterval = 3500 * 1000;
